import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CustomMessagesResponseEntity } from '../../domain/entities/CustomMessagesResponseEntity'
import { CustomMessageMiniModel } from './CustomMessageMiniModel'
import type { Pagination1OfCustomMessagesListedDto } from '@/backend/market'

export class CustomMessagesResponseModel extends CustomMessagesResponseEntity {
  constructor(dataDto: Pagination1OfCustomMessagesListedDto) {
    super()
    const customMessagesMiniModels = dataDto.items?.map((item) => new CustomMessageMiniModel(item))
    mapEntityProperties<CustomMessagesResponseEntity>(this, dataDto, {
      map: {
        items: customMessagesMiniModels
      }
    })
  }
}
